module.exports = __webpack_public_path__ + "img/landing-title-0.045c09d1.svg";